import { Fragment, type ReactNode } from 'react';

/**
 * 평문 텍스트 안의 URL 을 클릭 가능한 링크로 변환.
 *  - http(s):// 또는 www. 로 시작하는 주소를 인식.
 *  - 문자열 부분은 React 가 자동 escape 하므로 XSS 안전(앵커는 http/https 로만 생성).
 *  - 외부 링크: target=_blank + rel="noopener noreferrer nofollow".
 */
const URL_RE = /(https?:\/\/[^\s<]+|www\.[^\s<]+)/gi;

export function Linkify({ text }: { text: string }) {
  if (!text) return null;
  const parts: ReactNode[] = [];
  let last = 0;
  let key = 0;
  URL_RE.lastIndex = 0;
  let m: RegExpExecArray | null;
  while ((m = URL_RE.exec(text)) !== null) {
    if (m.index > last) parts.push(text.slice(last, m.index));
    let url = m[0];
    // URL 끝에 붙은 문장부호는 링크에서 제외
    let trail = '';
    const tm = /[.,!?)\]}'"·…]+$/.exec(url);
    if (tm) {
      trail = tm[0];
      url = url.slice(0, url.length - trail.length);
    }
    const href = url.startsWith('www.') ? `https://${url}` : url;
    parts.push(
      <a
        key={key++}
        href={href}
        target="_blank"
        rel="noopener noreferrer nofollow"
        className="text-[var(--color-primary)] underline break-all"
      >
        {url}
      </a>,
    );
    if (trail) parts.push(trail);
    last = m.index + m[0].length;
  }
  if (last < text.length) parts.push(text.slice(last));
  return <Fragment>{parts}</Fragment>;
}
